export default require('./PublicationDate').default
